import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import CookieFloatingButton from './cookie/CookieFloatingButton';
import CookieBanner from './cookie/CookieBanner';
import CookieModal from './cookie/CookieModal';
import { useCookieCategories } from './cookie/cookieUtils';
import { useCookiePreferences } from './cookie/useCookiePreferences';

const CookieConsent = () => {
  const { t } = useLanguage();
  const [showModal, setShowModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const {
    showBanner,
    hasAccepted,
    preferences,
    acceptAll,
    rejectAll,
    savePreferences,
    togglePreference,
  } = useCookiePreferences();

  const categories = useCookieCategories(t);

  const handleAcceptAll = () => {
    acceptAll();
    setShowModal(false);
  };
  const handleRejectAll = () => {
    rejectAll();
    setShowModal(false);
  };
  const handleSavePreferences = () => {
    savePreferences();
    setShowModal(false);
  };

  return (
    <>
      <AnimatePresence>
        {showBanner && !hasAccepted && !showModal && (
          <CookieBanner
            onCustomise={() => setShowModal(true)}
            onAcceptAll={handleAcceptAll}
            onRejectAll={handleRejectAll}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {hasAccepted && !showModal && (
          <CookieFloatingButton onClick={() => setShowModal(true)} />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showModal && (
          <CookieModal
            isOpen
            onClose={() => setShowModal(false)}
            categories={categories}
            preferences={preferences}
            onToggle={togglePreference}
            showDetails={showDetails}
            onToggleDetails={() => setShowDetails(!showDetails)}
            onAcceptAll={handleAcceptAll}
            onRejectAll={handleRejectAll}
            onSavePreferences={handleSavePreferences}
            t={t}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default CookieConsent;
